<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sms</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="sms" :search="search">
              <template v-slot:item.status="{ item }">
                <v-btn v-if="item.status == 2" color="green" text
                  ><v-icon left>mdi-check</v-icon>Sent</v-btn
                >

                <v-btn v-else color="red" text
                  ><v-icon left>mdi-close</v-icon>Failed</v-btn
                >
              </template>

              <template v-slot:item.message="{ item }">
                <div style="width: 600px">{{ item.message }}</div>
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ item.created_at | date }}
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Sms", value: "message" },
      { text: "Phone Number", value: "phone_number" },
      { text: "Date", value: "created_at" },
      { text: "Sms", value: "status" },
    ],
    sms: [],
  }),
  methods: {
    getSms() {
      const self = this;
      this.$store
        .dispatch("get", `/sms-reports`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.sms = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getSms();
  },
};
</script>